// Função pura, irmã de avisoAlvejaPerfil.ts: um item de Novidades TI atinge um
// perfil quando não tem departamentos_alvo (null/vazio = todo staff, o alvo
// padrão de todo item — targeting só existe a partir da publicação) ou quando
// QUALQUER departamento do perfil (legado ou o array novo) bate com QUALQUER um
// dos alvos, ignorando acento/caixa/hífen. Diferente de avisoAlvejaPerfil: o
// alvo aqui é plural (várias equipes podem ver a mesma publicação), escolhido
// no modal de publicação (NovidadesTiView.tsx), não por item.
//
// Usada em dois lugares: AvisosSistemaGate.tsx (filtra o feed antes de decidir
// se há novidade pendente) e NovidadesTiView.tsx (quantos colaboradores
// elegíveis por lote publicado, pro "N de M já viram").

import { normalizarDepartamento } from './departamentos.ts';

export interface PerfilParaAlvo {
    departamento?: string | null;
    departamentos?: string[] | null;
}

export function departamentosAlvejamPerfil(alvos: string[] | null | undefined, perfil: PerfilParaAlvo): boolean {
    if (!alvos || alvos.length === 0) return true;
    const alvosNormalizados = alvos.map(normalizarDepartamento);
    const deptsPerfil = [
        ...(perfil.departamentos ?? []),
        ...(perfil.departamento ? [perfil.departamento] : []),
    ].map(normalizarDepartamento);
    return deptsPerfil.some((d) => alvosNormalizados.includes(d));
}
